import styled from "styled-components";
import PageTopTitle from "../../components/shared/PageTopTitle";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  getAdminAraclarToExcel,
  getAllTruckAndTrailer,
} from "../../features/admin2/admin2Slice";
import { useSelector } from "react-redux";
 
import Btn from "../../components/shared/button/Btn";
import { showModal } from "../../features/modal/modalSlice";
import { useState } from "react";
import AdminAraclarContainer from "../../components/adminContainers/AdminAraclarContainer";
import Pagination from "../../components/shared/Pagination";
import InputText from "../../components/shared/input/new/InputText";
import InputSelect from "../../components/shared/input/new/InputSelect";
import locationData from "../../utils/locationData/locationOptions";
import InputNewAracTypeSelect from "../../components/shared/input/new/InputNewAracTypeSelect";
import InputCaseTypeSelect from "../../components/shared/input/new/InputCaseTypeSelect";
import { getAracTypes } from "../../features/adminSett/adminSettSlice";
import { AdminAracEkleOptions } from "../../utils/adminAracEkleOptions";
import InputCityTown from "../../components/shared/input/new/InputCityTown";

const Container = styled.div`
  width: 100%;
  height: auto;

  .wrapper {
    width: 100%;
    padding: 30px;
    .top-container {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
      flex-direction: column;
      .filter-container {
        display: flex;
        gap: 10px;
        margin-bottom: 15px;
      }

      .btn-container {
        display: flex;
        gap: 20px;
      }
    }
    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .titles {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
        gap: 10px;
        padding-inline: 10px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);
        text-align: center;
        color: ${({ theme }) => theme.mainTextColor};
      }
    }
  }
`;

const AdminAraclar = () => {
  const statusData = [
    {
      id: 1,
      text: "Aktif",
    },
    {
      id: 2,
      text: "Pasif",
    },
  ];

  const dispatch = useDispatch();
  const { adminAraclar, adminAraclarCount } = useSelector((state) => state.admin2);
  const [filterValues, setFilterValues] = useState({
    plaka: "",
    phoneNumber: "",
    adSoyadUnvan: "",
    "tcNo": ""
  });
  const [statusInfo, setStatusInfo] = useState("");
  const [location, setLocation] = useState(null)
  const [aracTipi, setAracTipi] = useState(null)
  const [kasaTipi, setKasaTipi] = useState(null)

  const [initialCaseType, setInitialCaseType] = useState(null)

  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 10;

  const totalPages = Math.ceil(adminAraclarCount / itemsPerPage);

  const titles = [
    "Ad Soyad",
    "Telefon Numarası",
    "Plaka",
    "Araç Türü",
    "Araç Tipi",
    "Kasa Tipi",
    "Firma",
    "Belge",
  ];

  useEffect(() => {
    
    dispatch(getAllTruckAndTrailer({ currentPage: currentPage, plaka: filterValues?.plaka || "", phoneNumber: filterValues?.phoneNumber || "", aktifPasif: statusInfo?.text?.toLowerCase() || "", adSoyadUnvan: filterValues?.adSoyadUnvan || "" }));
  }, [ dispatch, currentPage, filterValues?.plaka, filterValues?.phoneNumber, statusInfo?.text, filterValues?.adSoyadUnvan]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "plaka") {
      const newValue = value.replace(/\s/g, '');
      setFilterValues((prev) => ({ ...prev, [name]: newValue }));
    } else {
      setFilterValues((prev) => ({ ...prev, [name]: value }));
    }
  };

  const clearInput = () => {
    setFilterValues({
      plaka: "",
      phoneNumber: "",
    });
    setStatusInfo("");
  };

  return (
    <Container>
      <PageTopTitle title={"Araçlar"} />
      <div className="wrapper">
        <div className="top-container">
          <div className="filter-container">
            <InputText data={filterValues.adSoyadUnvan || ""} setData={(e) => handleChange(e)} inputWidth={"100%"} labelText="Ad Soyad" name={"adSoyadUnvan"} />
            <InputText data={filterValues.plaka || ""} setData={(e) => handleChange(e)} inputWidth={"100%"} labelText="Plaka" name={"plaka"} isBold={true} />
            <InputText data={filterValues.phoneNumber || ""} setData={(e) => handleChange(e)} inputWidth={"100%"} labelText="Telefon Numarası" name={"phoneNumber"} />
            <InputText data={filterValues.tcNo || ""} setData={(e) => handleChange(e)} inputWidth={"100%"} labelText="TC No" name={"tcNo"} />
            <InputCityTown initialOptions={locationData} data={location?.location || ""} setData={setLocation} inputWidth={"100%"} labelText="İl / İlçe" name={"ililce"} />
            <InputNewAracTypeSelect setInitialCaseType={setInitialCaseType} initialOptions={AdminAracEkleOptions} data={aracTipi?.name || ""} setData={setAracTipi} inputWidth={"100%"} labelText="Araç Türü" name={"aracTuru"} />
            <InputCaseTypeSelect initialOptions={initialCaseType} data={kasaTipi?.name || ""} setData={setKasaTipi} inputWidth={"100%"} labelText="Kasa Tipi" name={"kasaTipi"} />
            <InputSelect initialOptions={statusData} data={statusInfo.text || ""} setData={setStatusInfo} inputWidth={"100%"} labelText="Aktif/Pasif" name={"statusInfo"} />
            <Btn handleClick={clearInput} bgColor="transparent" padding="10px" color="#E85446">Temizle</Btn>
          </div>

          <div className="btn-container">
            <Btn handleClick={()=>dispatch(showModal("adminAraclarTekliAracEkle"))} bgColor="transparent" borderColor="#E85446" color="#E85446" width={"130px"}>Araç Ekle</Btn>
            <Btn handleClick={()=>dispatch(getAdminAraclarToExcel())} bgColor="transparent" borderColor="#E85446" color="#E85446" width={"130px"}>Excel Çıktısı</Btn>
            <Btn handleClick={()=>dispatch(showModal("adminTopluAracEkleModal"))} bgColor="transparent" borderColor="#E85446" color="#E85446" width={"130px"}>Toplu Araç Ekle</Btn>
            <Btn handleClick={()=>dispatch(showModal("adminAraclarİslemlerOptions")) } bgColor="transparent" borderColor="#E85446" color="#E85446" width={"130px"}>İşlemler</Btn>
          </div>
        </div>

        <div className="content">
          <div className="titles">
            {titles.map((item) => (
              <div>{item}</div>
            ))}
          </div>
          {adminAraclar.map((item) => (
            <AdminAraclarContainer data={item} />
          ))}
        </div>

        {(adminAraclar || adminAraclar?.length > 0) && (
          <Pagination
            totalPages={totalPages}
            handleClick={setCurrentPage}
            currentPage={currentPage}
          />
        )}
      </div>
    </Container>
  );
};

export default AdminAraclar;
